import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { t } from 'translation'

import AuthErrorBox from 'components/Auth/AuthErrorBox'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'

const setPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required('PASSWORD_IS_REQUIRED')
    .min(6, 'PASSWORD_IS_TOO_SHORT')
    .max(256, 'PASSWORD_IS_TOO_LONG')
    .matches(
      /^.*(?=.{6,})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'PASSWORD_MUST_CONTAIN'
    ),
  passwordConfirm: Yup.string()
    .required('PASSWORD_IS_REQUIRED')
    .oneOf([Yup.ref('password')], 'PASSWORDS_DO_NOT_MATCH'),
})

const AuthSetPasswordForm = ({
  submitFormHandler,
  apiResponseError,
  resetApiResponseError,
  loading,
}) => {
  const [showPasswords, setShowPasswords] = useState(false)
  return (
    <Formik
      initialValues={{ password: '', passwordConfirm: '' }}
      validationSchema={setPasswordSchema}
      onSubmit={submitFormHandler}
    >
      {({ errors, touched, submitForm }) => (
        <Form className="tab_content login_mod active_tab">
          <h2 className="section_title v3_mod center_level_mod color_mod offset_v3_mod">
            {t('auth.SET_YOUR_PASSWORD')}
          </h2>
          <AuthErrorBox
            formFields={['password', 'passwordConfirm']}
            formTouched={touched}
            formErrors={errors}
            apiResponseError={apiResponseError}
            resetApiResponseError={resetApiResponseError}
          />
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dt className="form_cell_title form_v3_mod">
                <label htmlFor="passwordEntry">{t('auth.PASSWORD')}</label>
              </dt>
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className="form_field default_mod v3_mod"
                  name="password"
                  type={showPasswords ? 'text' : 'password'}
                  id="passwordEntry"
                  placeholder="++++++"
                  disabled={loading}
                />
              </dd>
            </dl>
          </div>
          <div className="form_controller login_mod">
            <dl className="form_cell form_cell_v1_mod">
              <dt className="form_cell_title form_v3_mod">
                <label htmlFor="passwordConfirmEntry">{t('auth.PASSWORD_CONFIRM')}</label>
              </dt>
              <dd className="form_field_wrap form_v3_mod">
                <Field
                  className="form_field default_mod v3_mod"
                  name="passwordConfirm"
                  type={showPasswords ? 'text' : 'password'}
                  id="passwordConfirmEntry"
                  placeholder="++++++"
                  disabled={loading}
                />
              </dd>
            </dl>
          </div>
          <div className="login_bottom">
            <LoadingButton
              className="btn_base_v1"
              type="submit"
              isLoading={loading}
              onClick={submitForm}
            >
              {t('auth.SET_PASSWORD')}
            </LoadingButton>
          </div>
        </Form>
      )}
    </Formik>
  )
}
const mapStateToProps = ({ auth: { loading } }) => ({ loading })

export default connect(mapStateToProps)(AuthSetPasswordForm)

// AuthSetPasswordForm.propTypes = {
//   submitFormHandler: PropTypes.func.isRequired,
//   resetPasswordLink: PropTypes.string.isRequired,
//   apiResponseError: PropTypes.string.isRequired,
//   resetApiResponseError: PropTypes.func.isRequired,
// }
